import React from 'react'
import { Route, Routes } from "react-router-dom"
import LegCreateScreen from "screens/App/CRM/Legs/LegCreateScreen"
import LegDetailScreen from "screens/App/CRM/Legs/LegDetailScreen"
import LegEditScreen from "screens/App/CRM/Legs/LegEditScreen"
import LegListScreen from "screens/App/CRM/Legs/LegListScreen"

import NotFoundScreen from "screens/NotFoundScreen"

const LegRouter = () => {
    return (
        <Routes>
            <Route path="create" element={<LegCreateScreen />} />

            <Route path="list" element={<LegListScreen />} />

            <Route path=":id/detail" element={<LegDetailScreen />} />

            <Route path=":id/edit" element={<LegEditScreen />} />

            <Route path="*" element={<NotFoundScreen />} />

        </Routes>
    )
}

export default LegRouter